<mzima-client-button
  tabindex="-1"
  fill="outline"
  [iconOnly]="true"
  color="light-gray"
  [data-qa]="'btn-close'"
  class="modal__close-btn"
  [mat-dialog-close]="false"
  ariaLabel="{{ 'modal.button.close' | translate }}"
>
  <mat-icon icon svgIcon="close"></mat-icon>
</mzima-client-button>

<strong mat-dialog-title>{{ 'survey.choose_survey' | translate }}</strong>

<div mat-dialog-content>
  <app-spinner class="spinner" *ngIf="!surveys"></app-spinner>
  <ul role="list" class="types-list" [data-qa]="'add-post-modal-surveys'">
    <li *ngFor="let survey of surveys | async">
      <div
        matRipple
        role="listitem"
        [ngStyle]="{ '--color': survey.color }"
        [mat-dialog-close]="{ type: survey.id }"
        class="type-item"
        [data-qa]="'add-post-modal-surveys-item' + survey.id"
      >
        {{ survey.name }}
      </div>
    </li>
  </ul>
</div>
